// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================= */
/* ADMIN LAYOUT */
/* ============================= */

.admin-page {
  padding: 24px;
  background: #f7f9fc;
  min-height: calc(100vh - 60px);
}

.admin-page h2 {
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
}

/* ============================= */
/* ADMIN TABLE */
/* ============================= */

.admin-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}

.admin-table th,
.admin-table td {
  padding: 12px 14px;
  text-align: left;
  font-size: 14px;
  border-bottom: 1px solid #e5e7eb;
}

.admin-table th {
  background: #f1f5f9;
  font-weight: 600;
  color: #374151;
}

.admin-table tr:last-child td {
  border-bottom: none;
}

/* ============================= */
/* ADMIN BUTTONS */
/* ============================= */

.admin-btn {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
}

.admin-btn.primary {
  background: #2563eb;
  color: #ffffff;
}

.admin-btn.primary:hover {
  background: #1e4fd6;
}

.admin-btn.success {
  background: #16a34a;
  color: #ffffff;
}

.admin-btn.disabled {
  background: #9ca3af;
  color: #ffffff;
  cursor: not-allowed;
}

/* ============================= */
/* STATUS TAGS */
/* ============================= */

/* STATUS BADGES */
.admin-status {
  display: inline-block;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 6px;
  text-transform: uppercase;
  width: 70px;
}

/* APPROVED → Yellowish */
.admin-status.approved {
  background-color: #fff3cd;
  color: #856404;
}

/* FAILED → Reddish */
.admin-status.failed {
  background-color: #f8d7da;
  color: #721c24;
}

/* COMPLETED → Greenish */
.admin-status.completed {
  background-color: #d4edda;
  color: #155724;
}


.admin-status.previewed {
  background: #e0f2fe;
  color: #0369a1;
}

/* ============================= */
/* ADMIN MODAL BACKDROP (future) */
/* ============================= */

.admin-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.admin-modal {
  background: #ffffff;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
  padding: 20px;
}

.system-prompt-modal {
  width: min(960px, 92vw);
  max-width: 92vw;
  max-height: 86vh;
  overflow-y: auto;
}

.datatable-search {
  padding: 8px 12px;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
  width: 260px;
  font-size: 14px;
}

.system-prompt-loader {
  min-height: 180px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.system-prompt-loader-spinner {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 3px solid #dbeafe;
  border-top-color: #2563eb;
  animation: system-prompt-spin 0.8s linear infinite;
}

.system-prompt-loader-text {
  font-size: 13px;
  color: #334155;
  font-weight: 600;
}

@keyframes system-prompt-spin {
  to {
    transform: rotate(360deg);
  }
}
/* ADMIN ACTION BUTTONS */
.admin-btn {
  min-width: 120px;
  text-align: center;
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

/* Primary (Materialize) */
.admin-btn.primary {
  background-color: #2563eb;
  color: #fff;
}

/* Success (View Details) */
.admin-btn.success {
  background-color: #16a34a;
  color: #fff;
}

.admin-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* MODAL BACKDROP */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* FULL SCREEN MODAL */
.modal-full {
  background: #fff;
  width: 95vw;
  height: 95vh;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

/* HEADER */
.modal-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
}

/* BODY */
.modal-body {
  padding: 16px;
  flex: 1 1;
  overflow: hidden;
}

/* BUTTON VARIANTS */
.admin-btn.secondary {
  background: #334155;
  color: #fff;
  margin-right: 10px;
}

.admin-btn.danger {
  background: #dc2626;
  color: #fff;
}
.run-prompt-box {
  background: #f5f7fa;
  border-left: 4px solid #2563eb;
  padding: 12px 14px;
  margin: 12px 0 16px;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  max-height: 120px;
  overflow-y: auto;
  color: #1f2937;
}

.modal.full {
  width: 95%;
  height: 90%;
  max-width: none;
  display: flex;
  flex-direction: column;
}

.btn {
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
}

.btn.secondary {
  background: #374151;
  color: #fff;
}

.btn.secondary:hover {
  background: #1f2937;
}

.btn.danger {
  background: #dc2626;
  color: #fff;
}

.btn.danger:hover {
  background: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/styles/admin.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC,iBAAiB;AACjB,kCAAkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kCAAkC;AAClC,gBAAgB;AAChB,kCAAkC;;AAElC;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC,kBAAkB;AAClB,kCAAkC;;AAElC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC,gBAAgB;AAChB,kCAAkC;;AAElC,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;AAChB;;;AAGA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kCAAkC;AAClC,kCAAkC;AAClC,kCAAkC;;AAElC;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ============================= */\n/* ADMIN LAYOUT */\n/* ============================= */\n\n.admin-page {\n  padding: 24px;\n  background: #f7f9fc;\n  min-height: calc(100vh - 60px);\n}\n\n.admin-page h2 {\n  margin-bottom: 16px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n/* ============================= */\n/* ADMIN TABLE */\n/* ============================= */\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #ffffff;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n}\n\n.admin-table th,\n.admin-table td {\n  padding: 12px 14px;\n  text-align: left;\n  font-size: 14px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.admin-table th {\n  background: #f1f5f9;\n  font-weight: 600;\n  color: #374151;\n}\n\n.admin-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* ============================= */\n/* ADMIN BUTTONS */\n/* ============================= */\n\n.admin-btn {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.admin-btn.primary {\n  background: #2563eb;\n  color: #ffffff;\n}\n\n.admin-btn.primary:hover {\n  background: #1e4fd6;\n}\n\n.admin-btn.success {\n  background: #16a34a;\n  color: #ffffff;\n}\n\n.admin-btn.disabled {\n  background: #9ca3af;\n  color: #ffffff;\n  cursor: not-allowed;\n}\n\n/* ============================= */\n/* STATUS TAGS */\n/* ============================= */\n\n/* STATUS BADGES */\n.admin-status {\n  display: inline-block;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 6px;\n  text-transform: uppercase;\n  width: 70px;\n}\n\n/* APPROVED → Yellowish */\n.admin-status.approved {\n  background-color: #fff3cd;\n  color: #856404;\n}\n\n/* FAILED → Reddish */\n.admin-status.failed {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n/* COMPLETED → Greenish */\n.admin-status.completed {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n\n.admin-status.previewed {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n/* ============================= */\n/* ADMIN MODAL BACKDROP (future) */\n/* ============================= */\n\n.admin-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.admin-modal {\n  background: #ffffff;\n  border-radius: 8px;\n  width: 500px;\n  max-width: 90%;\n  padding: 20px;\n}\n\n.system-prompt-modal {\n  width: min(960px, 92vw);\n  max-width: 92vw;\n  max-height: 86vh;\n  overflow-y: auto;\n}\n\n.datatable-search {\n  padding: 8px 12px;\n  border: 1px solid #c7d2fe;\n  border-radius: 6px;\n  width: 260px;\n  font-size: 14px;\n}\n\n.system-prompt-loader {\n  min-height: 180px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.system-prompt-loader-spinner {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 3px solid #dbeafe;\n  border-top-color: #2563eb;\n  animation: system-prompt-spin 0.8s linear infinite;\n}\n\n.system-prompt-loader-text {\n  font-size: 13px;\n  color: #334155;\n  font-weight: 600;\n}\n\n@keyframes system-prompt-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* ADMIN ACTION BUTTONS */\n.admin-btn {\n  min-width: 120px;\n  text-align: center;\n  padding: 6px 14px;\n  font-size: 13px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n\n/* Primary (Materialize) */\n.admin-btn.primary {\n  background-color: #2563eb;\n  color: #fff;\n}\n\n/* Success (View Details) */\n.admin-btn.success {\n  background-color: #16a34a;\n  color: #fff;\n}\n\n.admin-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* MODAL BACKDROP */\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* FULL SCREEN MODAL */\n.modal-full {\n  background: #fff;\n  width: 95vw;\n  height: 95vh;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* HEADER */\n.modal-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  margin: 0;\n}\n\n/* BODY */\n.modal-body {\n  padding: 16px;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* BUTTON VARIANTS */\n.admin-btn.secondary {\n  background: #334155;\n  color: #fff;\n  margin-right: 10px;\n}\n\n.admin-btn.danger {\n  background: #dc2626;\n  color: #fff;\n}\n.run-prompt-box {\n  background: #f5f7fa;\n  border-left: 4px solid #2563eb;\n  padding: 12px 14px;\n  margin: 12px 0 16px;\n  font-size: 14px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  max-height: 120px;\n  overflow-y: auto;\n  color: #1f2937;\n}\n\n.modal.full {\n  width: 95%;\n  height: 90%;\n  max-width: none;\n  display: flex;\n  flex-direction: column;\n}\n\n.btn {\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n}\n\n.btn.secondary {\n  background: #374151;\n  color: #fff;\n}\n\n.btn.secondary:hover {\n  background: #1f2937;\n}\n\n.btn.danger {\n  background: #dc2626;\n  color: #fff;\n}\n\n.btn.danger:hover {\n  background: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
